import type { SubscriptionPlanStatus } from '../../types';

export const getStatusBadgeColor = (status: SubscriptionPlanStatus | null) => {
  switch (status) {
    case 'Active':
      return 'success';
    case 'Paused':
      return 'warning';
    case 'Cancelled':
      return 'danger';
    default:
      return 'secondary';
  }
};

export const formatStatus = (status: SubscriptionPlanStatus | null): string => {
  if (!status) return '-';
  return status.charAt(0).toUpperCase() + status.slice(1);
};

export const formatProblemCode = (code: string | null | undefined): string => {
  if (code == null) return '-';
  const formatted = code.replace(/([a-z])([A-Z])/g, '$1 $2');
  return formatted;
};
